import type { ComparisonDataEntry } from '../Comparison/useLinearizeComparisonData'

export const estimateChangeTableSize = (entry: ComparisonDataEntry) => {
  switch (entry.type) {
    case 'group': {
      const anyGroup = entry.base ?? entry.comparison
      if (!anyGroup?.parentGroup) {
        return 50
      }
      return 41
    }
    case 'family':
      return 34
  }
}
